import { BrowserStorageService } from 'services/BrowserStorageService';

const LocalStorageService = BrowserStorageService('local');

export { LocalStorageService };
